import { z } from 'zod'

/**
 * Single URL search param shared by the informations, assurances, and checkout
 * steps once a booking session has been created.
 *
 * Replaces the 20-30 params previously threaded through
 * informations-search.schema.ts, assurances-search.schema.ts, and
 * checkout-search.schema.ts.
 */
export const bookingSessionSearchSchema = z.object({
  session: z.string().cuid2(),
})

export type BookingSessionSearchParams = z.infer<typeof bookingSessionSearchSchema>
